export default "__VITE_ASSET__C0joSoj3__"